import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { MessageService } from '../service/message.service';

@Component({
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {}

  showInsertNdg(): boolean {
    return this.authService.hasAuthority('ANAG_CENSUS');
  }

  doLogout(): void {
    this.authService.logout();
    this.messageService.success('logout.message');
    this.router.navigate(['/login']);
  }

  get userFullName(): string {
    return this.authService.currentUserValue.name;
  }
}
